import React, { useEffect, useState } from 'react';
import OlcButton from '~/components/General/OlcButton';

// Hooks
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { fetchContactImports } from '~/redux/actions/contact-import-actions';

// Utils
import { MESSAGES } from '~/utils/message';
import { DEFAULT_PAGINATION } from '~/utils/constants';

// Component
import ContactImportTable from './ImportTable';

// MUI Components
import { Box, Typography } from '@mui/material';

// Icons
import { ImportLightCIcon, BtnDownloadIcon } from '~/assets/images';

import { useNavigate } from 'react-router-dom';

const Import = () => {
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
  const [initialLoad, setInitialLoad] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const rowsCount = useSelector((state) => state.contactImportsReducers.rowsCount) || 0;

  useEffect(() => {
    const payload = {
      page: pagination?.page || DEFAULT_PAGINATION.page,
      pageSize: pagination?.pageSize || DEFAULT_PAGINATION.pageSize,
    };
    let isActive = true;

    dispatch(fetchContactImports(payload)).finally(() => {
      if (isActive) {
        setInitialLoad(false);
      }
    });

    return () => {
      isActive = false;
    };
  }, [dispatch, pagination.page, pagination.pageSize]);

  return (
    <>
      <Box className="importExportTabContent">
        {rowsCount > 0 && (
          <Box className="olcHeaderWrap importExportListHeader">
            <Box>
              <Typography className="pageTitle" variant="h4">
                {MESSAGES.ACCOUNT.CONTACT_IMPORT.TITLE}
              </Typography>
            </Box>

            <Box className="pageNewBtn">
              <OlcButton
                variant="primary"
                sx={{ width: '191px' }}
                onClick={() => {
                  navigate('/contacts/import');
                }}
              >
                <img src={BtnDownloadIcon} alt="download" />
                <Typography>{MESSAGES.CONTACTS.NO_CONTACTS_SCREEN.IMPORT_BTN_TEXT}</Typography>
              </OlcButton>
            </Box>
          </Box>
        )}
        <ContactImportTable
          pagination={pagination}
          updatePagination={setPagination}
          initialLoad={initialLoad}
        />
      </Box>
    </>
  );
};

export default Import;
